.messagesContainer {
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 331px;

  p {
    margin: 0;
  }

  .messagesList {
    display: flex;
    flex-direction: column;
  }
}
